import BaseAPI from './base.api.service'

const resource = 'snapshots';
export default {
    async get(erid, params) {
        params = params || '';
        return await BaseAPI.get(`ExpenseReports/${erid}/${resource}${params}`);
    }
}